module.exports = __webpack_public_path__ + "static/img/auditing.eda566e5.svg";